/**
 * @Description 拓店-标准版本-机会点
 */

import { get, post } from '@/common/request/index';



/**
 * @description 机会点管理-机会点列表
 * @yapi https:// yapi.lanhanba.com/project/532/interface/api/55509
 */
export function getChancePointList(params?:any) {
  return post('/standard/chancePoint/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点管理-机会点详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55530
 */
export function getChancePointDetail(params) {
  return post('/standard/chancePoint/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needCancel: false,
    needHint: true,
  });
}

/**
 * 创建踩点任务
 * https://yapi.lanhanba.com/project/532/interface/api/55628
 */
export function footprintCreate(params: any) {
  return post('/standard/checkSpotProject/create', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    isZeus: false,
  });
}

/**
 * 机会点表单页
 * https://yapi.lanhanba.com/project/532/interface/api/55908
 */
export function getFormDetail(params:any) {
  return post(`/standard/chancePoint/formDetail`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    isZeus: false,
  });
}

/**
 * PC模版列表
 * https://yapi.lanhanba.com/project/532/interface/api/55831
 */

export function getTemplateLists() {
  return post('/standard/template/lists', {}, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}
/**
 * PC模版详情
 * https://yapi.lanhanba.com/project/532/interface/api/55838
 */
export function getTemplateDetail(params:any) {
  return post(`/standard/template/query`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}
/**
 * PC机会点保存
 * https://yapi.lanhanba.com/project/532/interface/api/55796
 */
export function saveChancePoint(params:any) {
  return post(`/standard/chancePoint/save`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}


/**
 * @description 机会点详情-模板导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55852
 */
export function exportTemplateChancePoint(params) {
  return post('/standard/template/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情-机会点导入
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55866
 */
export function importChancePoint(params) {
  return post('/standard/chancePoint/import', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情-机会点导入历史
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55880
 */
export function importChancePointRecords(params) {
  return get('/standard/chancePoint/import/records', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情-机会点模板状态
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/55859
 */
export function importChancePointStatus(params) {
  return post('/standard/chancePoint/import/status', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * PC端机会点分页(动态配置列)
 * https://yapi.lanhanba.com/project/532/interface/api/59317
 */
export function getDynamicDetail(params) {
  return post(`/standard/chancePoint/dynamicPage`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * PC端机会点分页(动态配置列)
 * https://yapi.lanhanba.com/project/532/interface/api/59317
 */
export function getDynamicDetailShare(params) {
  return post(`/standard/share/chancePoint/dynamicPage`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 机会点列表(益禾堂)
 * https://yapi.lanhanba.com/project/532/interface/api/82396
 */
export function getChancePointYhtPage(params) {
  return post(`/standard/chancePoint/yhtPage`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 删除机会点
 * https://yapi.lanhanba.com/project/532/interface/api/75319
 */
export function deleteChancepoint(params) {
  return post(`/standard/chancePoint/delete`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * PC端机会点机会点下拉框
 * https://yapi.lanhanba.com/project/532/interface/api/59583
 */
export function getChancepointSelection(params, config?: any) {
  return get(`/standard/chancePoint/selection`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    ...config,
  });
}

/**
 * 导出机会点
 * https://yapi.lanhanba.com/project/532/interface/api/63300
 */
export function chancepointExport(params) {
  return post(`/standard/chancePoint/export`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 机会点列表导出(益禾堂)
 * https://yapi.lanhanba.com/project/532/interface/api/82410
 */
export function chancepointExportYht(params) {
  return post(`/standard/chancePoint/yhtExport`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 根据机会点经纬度查询最近的规划商圈
 * https://yapi.lanhanba.com/project/532/interface/api/60479
 */
export function chancepointPlanCluster(params) {
  return post(`/standard/chancePoint/planCluster`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 根据机会点经纬度获取获取客群质量评分
 * https://yapi.lanhanba.com/project/532/interface/api/61375
 */
export function chancepointFlowScore(params) {
  return post(`/standard/chancePoint/flowScore`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}
/**
 * PC录入的集客点详情
 * https://yapi.lanhanba.com/project/546/interface/api/62271
 */
export function getSpotRelationDetail(params) {
  return get(`/plan/spot/relation/detail`, params, {
    isMock: false,
    mockId: 546,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 根据机会点经纬度查询最近的选址地图商圈
 * https://yapi.lanhanba.com/project/532/interface/api/69544
 */
export function chancepointModelCluster(params) {
  return post(`/standard/chancePoint/modelCluster`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}


/**
 * 机会点报告首页
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancepointReportHomeData(params) {
  return post(`/standard/chancePoint/report/home`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}


/**
 * 新机会点编辑-地图poi类型
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancePointPoiTypes(params) {
  return post(`/standard/chancePoint/poi/types`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 新机会点编辑-地图poi列表(地图用)
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancePointPoiMapList(params) {
  return post(`/standard/chancePoint/poi/list`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 新机会点编辑-poi列表(分页用)
 * https://yapi.lanhanba.com/project/532/interface/api/70685
 */
export function chancePointPoiPage(params) {
  return post(`/standard/chancePoint/poi/page`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * 机会点列表表头
 * https://yapi.lanhanba.com/project/532/interface/api/78434
 */
export function chancePointThead(params) {
  return get(`/standard/chancePoint/header`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}


/**
 * @description PC新址评分保存
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59415
 */
export function saveSpotScore(params?:any) {
  return post('/standard/chance/point/score/save', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description PC新址评分列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/79918
 */
export function spotScoreList(params?:any) {
  return post('/standard/chance/point/score/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-点位测评-详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/79939
 */
export function chancePointEvaluation(params?:any) {
  return post('/standard/chancePoint/evaluation/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * @description 获取预估销售额、预估销售额上限及外卖销售额
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/88380
 */
export function chancePointEstimatedSales(params?:any, config?: any) {
  return post('/standard/chancePoint/estimatedSales', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    ...config
  });
}

/**
 * @description 机会点-废弃列表分页查询
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86603
 */
export function chancePointPageRecycle(params?:any) {
  return post('/standard/chancePoint/pageRecycle', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点详情(废弃库的机会点-详情)
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86610
 */
export function chancePointRecycleDetail(params?:any) {
  return post('/standard/chancePoint/recycleDetail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-废弃操作
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86589
 */
export function chancePointRecycle(params?:any) {
  return post('/standard/chancePoint/recycle', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 机会点-恢复(撤销废弃)
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/86596
 */
export function chancePointRecovery(params?:any) {
  return post('/standard/chancePoint/recovery', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 客流点位详情列表
 * @yapi https://yapi.lanhanba.com/project/329/interface/api/88610
 */
export function getTaskAnalysisList(params?:any) {
  return post('/checkSpot/device/taskSpotAnalysisList', params, {
    isMock: false,
    mockId: 329,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 当前点位周边客流点位
 * @yapi https://yapi.lanhanba.com/project/329/interface/api/88608
 */
export function getTaskSpotSimplePage(params?:any) {
  return post('/checkSpot/device/taskSpotSimplePage', params);
}
